import { GreenCtaButton } from '../../components/atomic/buttons/green_cta_button/GreenCtaButton';
import textImg from '../texts/take_order.png';

type ButtonProps = {
  onClick?: () => void;
  disabled?: boolean;
};

/** New delivery take-order CTA. */
export function Button({ onClick, disabled = false }: ButtonProps) {
  return (
    <GreenCtaButton
      textSrc={textImg}
      ariaLabel="Взять заказ"
      onClick={onClick}
      disabled={disabled}
      left={296}
      width={691}
      gradient={{ sizeX: 460.08, sizeY: 977.58, atX: 345.5, atY: 86.5 }}
      flash={{ left: 665.395, top: 23 }}
      textSize={{ width: 404, height: 105 }}
    />
  );
}
